import cookie from '@/plugins/cookie'

/*ACTIONS:  
    Process before commiting data via (mutations aka commit) 
    Accessed VIA - $store.dispatch([const] , [payload]);
*/

//System
const entryURL = function(context, payload){
    context.commit('entryURL',payload);
}
const library = function(context, payload){
    context.commit('library',payload);
}
const language = function(context, payload){
    context.commit('language',payload);
}

const session_id = function(context, payload){
    context.commit('session_id', payload);
}
const mode = function(context, payload){
    context.commit('mode', payload);
}
const ready = function(context, payload){
    context.commit('ready', payload);
}

const busy = function(context, payload){
    var value = context.state.busy;
    if(payload===true){
        value++;
    }else{
        value--;
        if(value<0){
            value = 0;
        }
    }

    context.commit('busy',value);
}

const progressBar = function(context, payload){
    var value = null;
    if(payload>=100){
        value = null;
    }else{
        value = payload;
    }
    context.commit('progressBar',value);
}

const window = function(context, payload){
    context.commit('window',payload);
}

const login = function(context, payload){
    context.commit('login',payload);
}

const loginRep = function(context, payload){
    context.commit('loginRep',payload);
}

const programAdmin = function(context, payload){
    context.commit('programAdmin', payload);
}

const programAdminQuickAccess = function(context, payload) {
    context.commit('programAdminQuickAccess', payload);
}

const contactUs = function(context, payload) {
    context.commit('contactUs', payload);
}

const editProfile = function(context, payload) {
    context.commit('editProfile', payload);
}

const siteRegulation = function(context, payload) {
    context.commit('siteRegulation', payload);
}

const accountValidation = function(context, payload) {
    context.commit('accountValidation', payload);
}

const accountValidationError = function(context, payload) {
    context.commit('accountValidationError', payload);
}

const siteRegulationTargetTab = function(context, payload){
    context.commit('siteRegulationTargetTab', payload);
}
//CSRF
const csrf = function(context, payload){
    cookie.set('csrf', payload);
    context.commit('csrf', payload);
}

const clear_csrf = function(context){
    cookie.clear('csrf');
    context.commit('csrf', false);
    context.commit('session_id',false);
}

//JWT
const jwt = function(context, payload){
    cookie.set('jwt', payload);
    context.commit('jwt', payload);
}

const clear_jwt = function(context){
    cookie.clear('jwt');
    context.commit('jwt', false);
    context.commit('user',false);
}

//User
const user = function(context, payload){   
    let currentUser =  JSON.parse(JSON.stringify(this.getters.user ? this.getters.user : {}));
    const updatedUser = Object.assign(currentUser,payload); //because store.user object has extended attributes beyond profile data like groups, programs    
    context.commit('user', updatedUser);
}

const logout = function(context){
    context.dispatch('clear_jwt');
    context.commit('user',false);
    context.commit('entryURL',null);
}

//Application
const programs = function(context, payload){
    context.commit('programs', payload);
}

const programStatus = function(context, payload){
    context.commit('programStatus', payload);
}

//Session A-live
const sessionLoggedDuration = function(context, payload){
    context.commit('sessionLoggedDuration', payload);
}

const sessionCreated = function(context, payload){
    context.commit('sessionCreated', payload);
}

const sessionUpdated = function(context, payload){
    context.commit('sessionUpdated', payload);
}

const sessionLoggedTrackingStarted = function(context, payload){
    context.commit('sessionLoggedTrackingStarted', payload);
}

const sessionLastActivity = function(context, payload){
    context.commit('sessionLastActivity', payload);
}

const userSession = function(context,payload){
    context.commit('userSession', payload);
}

const V3_PortalState = function(context, payload){
    context.commit('V3_PortalState',payload)
}

const updateFeaturedProgram = function(context, payload) {
    context.commit("setFeaturedProgram", payload)
}

export default{
    library,
    language,
    entryURL,
    session_id,
    mode,
    ready,
    busy,
    progressBar,
    window,
    csrf,
    clear_csrf,
    login,
    loginRep,
    programAdmin,
    programAdminQuickAccess,
    contactUs,
    editProfile,
    siteRegulation,
    accountValidation,
    accountValidationError,
    siteRegulationTargetTab,
    jwt,
    clear_jwt,
    user,
    logout,
    programs,
    programStatus,
    sessionLoggedDuration,
    sessionCreated,
    sessionUpdated,
    sessionLoggedTrackingStarted,
    sessionLastActivity,
    userSession,
    V3_PortalState,
    updateFeaturedProgram
}